
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";
import { Bar } from 'vue-chartjs';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

@Component({
  components: {
    Bar
  }
})
export default class PatientCenter extends Vue {
  chartDatas = {
    labels: [] as string[],
    datasets: [
      {
        label: "",
        backgroundColor:  ['#ffac1c',
          '#ff6f00',
          '#ffd700',
          '#ff8c00',
          '#ffa07a',
          '#ffc107'],
        data: [] as number[],
      }
    ]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    }
  };

  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("patientCenter");
  }

  get chartDataAvailable(): boolean {
    return this.chartDatas.labels.length > 0 && this.chartDatas.datasets[0].data.length > 0;
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("patientCenter");

      const rawData = this.rawChartData;
      const labels = rawData.map((entry: any) => entry.InstituteName);
      const data = rawData.map((entry: any) => entry.PatientCount);

      this.chartDatas = {
        labels,
        datasets: [
          {
            label: 'Top 10',
            backgroundColor:  ['#ffac1c',
              '#ff6f00',
              '#ffd700',
              '#ff8c00',
              '#ffa07a',
              '#ffc107'],
            data
          }
        ]

      };
    } catch (e) {
      console.error("Failed to load chart data", e);
    }
  }
}
